import { Member } from '../member/member.model';
import { CourseInstance } from './course-instance.model';

export class Registration {
  agent: string | Member;
  canceled?: boolean;
  dateCreated?: string;
  dateDeleted?: string;
  dateUpdated?: string;
  id?: string;
  isAbsent?: boolean;
  isOnWaitList: boolean;
  object: string | CourseInstance;
  registrationDate?: string;

  constructor(values= {}) {
    Object.assign(this, values);

    if (this.agent instanceof Object) {
      this.agent = this.agent ? new Member(this.agent) : this.agent;
    }
  }

  getInstanceId(): string {
    return typeof this.object === 'string' ? this.object.split('/').pop() : this.object.id;
  }

  getRegistrationDate(): string {
    return this.registrationDate ? this.registrationDate : this.dateCreated;
  }
}
